import { Button, Typography, ButtonProps } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { ReactNode } from "react";

type CustomDefaultProps = {
    label: string;
    customsx?: object;
    notFitContentWidth?: boolean;
    labelsx?: object;
    customicon?: ReactNode;
};

export default function DownloadBtn(props: ButtonProps & CustomDefaultProps) {
    const { label, customsx, labelsx, customicon } = props;
    return (
        <Button
            {...props}
            sx={{
                display: "inline-flex",
                height: "3rem",
                padding: "0rem 1.5rem;",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                flexShrink: 0,
                borderRadius: "1rem",
                background: props.disabled ? "#C8CDD0" : "#E5EEF5",
                textTransform: "none",
                border: "1px solid #E5EEF5",
                // width: "fit-content",
                margin: "auto",
                ...customsx,
                "&:hover": {
                    backgroundColor: "#fff",
                    color: "#005499",
                    border: "1px solid #005499",
                    "& .MuiTypography-root": {
                        color: "#005499", // Nouvelle couleur de la typographie
                    },
                    "& .MuiSvgIcon-root": {
                        color: "#005499", // Nouvelle couleur de l'icône
                    },
                },
            }}
        >
            {customicon ? (
                customicon
            ) : (
                <DownloadIcon
                    sx={{
                        color: "#005499",
                        width: "1.25rem",
                        height: "1.25rem",
                    }}
                />
            )}

            <Typography
                sx={{
                    color: props.disabled ? "#7A8185" : "#005499",
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                    ...labelsx,
                }}
            >
                {label}
            </Typography>
        </Button>
    );
}
